module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/025-e97975b49779e1dde2924440ea914d50.jpg";